import {DrawLineStepInterface} from '@modules/activities/core/models/draw-line-step.interface';

export interface DrawLineDataInterface {
    backgroundImagePath: string;
    steps: DrawLineStepInterface[];
}